import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost, unpublishDeviation } from '../../../../redux/deviations/actionCreators';
import { beginDeviationAwardBadgeFlow } from '../../../../coreBadge/redux/actionCreators';
import { focusCommentEditor } from '../../../../DeviationPage/redux/actions';
const mapStateToProps = (state, ownProps)=>({
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    showReportModal,
    shareDeviationToPost,
    showAwardBadgePopup: beginDeviationAwardBadgeFlow,
    onCommentClick: focusCommentEditor,
    onUnpublishClick: unpublishDeviation
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=MoreMenuContent.container.js.map